import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import './Header.less'

export const solutionData = [
  {
    title: 'ARTA 埃尔塔®',
    subTitle: '全年龄弱视治疗仪',
    router: 'arta',
    img: '/images/nav/arta.jpg',
  },
  {
    title: 'ARGOS 爱格视™',
    subTitle: '全功能3D近视训练仪',
    router: 'argos',
    img: '/images/nav/argos.jpg',
  },
  {
    title: 'EYEPAL 眼派™',
    subTitle: '可视温润舒眼仪',
    router: 'eyepal',
    img: '/images/nav/eyepal.jpg',
  },
  {
    title: '集视在研方案',
    subTitle: '创新青光眼治疗方案',
    router: 'glaucoma',
    img: '/images/nav/qgy.jpg',
  },
  {
    title: '集视在研方案',
    subTitle: '斜视术后康复数字疗法',
    router: 'strabismus',
    img: '/images/nav/xsshkf.jpg',
  },
]

export default function Header({ dark = false }) {
  const location = useLocation();
  const navigate = useNavigate();
  // console.log('location.pathname', location.pathname)
  const getHeaderMenuTitleClass = () => {
    switch (location.pathname) {
      case '/aboutUs':
      case '/productsIndex':
      case '/glaucoma':
      case '/strabismus':
        return 'c_ff';
      default:
        return 'c_23253B';
    }
  };
  const getLogoImg = () => {
    switch (location.pathname) {
      case '/aboutUs':
      case '/productsIndex':
      case '/glaucoma':
      case '/strabismus':
        return '/images/nav/logo-white.svg';
      default:
        return '/images/nav/logo-color.svg';
    }
  };

  const getUserIcon = () => {
    switch (location.pathname) {
      case '/aboutUs':
      case '/productsIndex':
      case '/glaucoma':
      case '/strabismus':
        return '/images/nav/user_icon_white.svg';
      default:
        return '/images/nav/user_icon_black.svg';
    }
  };

  const getLanguageIcon = () => {
    switch (location.pathname) {
      case '/aboutUs':
      case '/productsIndex':
      case '/glaucoma':
      case '/strabismus':
        return '/images/nav/language_icon_white.svg';
      default:
        return '/images/nav/language_icon_black.svg';
    }
  };

  const getMobileIcon = () => {
    switch (location.pathname) {
      case '/aboutUs':
      case '/productsIndex':
      case '/glaucoma':
      case '/strabismus':
        return '/images/nav/menu_icon_white.svg';
      default:
        return '/images/nav/menu_icon_black.svg';
    }
  };

  const FcstDate = [
    {
      name: '文献速递',
      router: 'fcst/literature',
    },
    {
      name: '科普专栏',
      router: 'fcst/sciencePopularization',
    },
  ]

  const [key, setKey] = useState(Date.now());
  useEffect(() => { // 当路径变化时执行刷新操作
    setKey(Date.now());
    setHovered(false)
  }, [location.pathname]);
  const [hovered, setHovered] = useState(false)

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProductsOpen, setIsProductsOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // 关闭菜单时也关闭子菜单
    if (isMenuOpen) setIsProductsOpen(false);
  };

  const toggleProductsMenu = (e) => {
    e.stopPropagation(); // 阻止事件冒泡
    setIsProductsOpen(!isProductsOpen);
  };


  return <div
    key={key}
    className={`Header ${dark ? 'ScrollY' : ''}`}
    onMouseEnter={() => setHovered(true)}
    onMouseLeave={() => setHovered(false)}
  >
    <div
      className='pageMargin'
      style={{ height: '100%' }}
    >
      <div
        className='flex_row flex_ai-c flex_jc-sb'
        style={{ width: '100%', height: '100%' }}
      >
        <Link to='/#homeCoverPage'
          className="Header_logo flex_auto"
          onClick={() => {
            document.scrollingElement.scrollTop = 0
            setIsMenuOpen(false)
            setIsProductsOpen(false)
          }}
        >
          <img
            style={{ width: '100%', height: 'auto' }}
            src={`${dark || hovered ? '/images/nav/logo-color.svg' : getLogoImg()}`}
            alt="" />
        </Link>
        {/* PC端导航 - 横向显示 */}
        <div className='Header_pc flex_full flex_row flex_ai-c flex_jc-fe'>
          <ul className='Header_menu'>
            <li>
              <Link to='/#homeCoverPage'
                className={`Header_menu-title ${getHeaderMenuTitleClass()} ${dark || hovered ? 'c_23253B' : ''}`}
              >
                首页
              </Link>
            </li>
            <li>
              <Link
                to='/productsIndex#coverPage'
                className={`Header_menu-title ${getHeaderMenuTitleClass()} ${dark || hovered ? 'c_23253B' : ''}`}
              >
                产品及解决方案
              </Link>
              <div className='Header_menu-item'>
                <div className="Header_menu-itemSolution mt_12">
                  <div className='ml_16 mr_16 pt_16 pb_35 flex_row gap_16'>
                    {solutionData.map((item, index) =>
                      <Link
                        to={item.router}
                        key={index}
                        className='Header_menu-solution'
                        onClick={() => {
                          document.scrollingElement.scrollTop = 0
                        }}
                      >
                        <div className='Header_menu-solutionImg'>
                          <img
                            src={item.img}
                            alt="" />
                        </div>
                        <div
                          className='Header_menu-solutionText'
                          style={{ color: location.pathname === `/${item.router}` ? '#2A82e4' : '' }}
                        >
                          <div style={{ fontWeight: 600 }}>{item.title}</div>
                          <div>{item.subTitle}</div>
                        </div>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </li>
            <li>
              <Link to='/companyNews'
                className={`Header_menu-title ${getHeaderMenuTitleClass()} ${dark || hovered ? 'c_23253B' : ''}`}
                onClick={() => {
                  document.scrollingElement.scrollTop = 0
                }}
              >
                公司动态
              </Link>
            </li>
            <li>
              <Link to='/fcst'
                className={`Header_menu-title ${getHeaderMenuTitleClass()} ${dark || hovered ? 'c_23253B' : ''}`}
                onClick={() => {
                  document.scrollingElement.scrollTop = 0
                }}
              >
                FCST研究院
              </Link>
              {/* <div className='Header_menu-item Header_menu-itemFcst'>
            {FcstDate.map((item, index) =>
              <Link
                to={item.router}
                key={index}
                style={{ color: location.pathname.toLowerCase().includes(`/${item.router}`.toLowerCase()) ? '#F0B000' : '' }}
                className="Header_menu-itemLink">
                {item.name}
              </Link>)}
          </div> */}
            </li>
            <li>
              <Link to='/aboutUs'
                className={`Header_menu-title ${getHeaderMenuTitleClass()} ${dark || hovered ? 'c_23253B' : ''}`}
                onClick={() => {
                  document.scrollingElement.scrollTop = 0
                }}
              >
                关于我们
              </Link>
              {/* <div className='Header_menu-item Header_menu-itemAboutUs'>
            <Link
              to='/companyProfile'
              className="Header_menu-itemLink"
              style={{ color: location.pathname === '/companyProfile' ? '#F0B000' : '' }}
              onClick={() => {
                document.scrollingElement.scrollTop = 0
              }}
            >
              公司简介
            </Link>
            <Link
              to='/contactUs'
              className="Header_menu-itemLink"
              style={{ color: location.pathname === '/contactUs' ? '#F0B000' : '' }}
              onClick={() => {
                document.scrollingElement.scrollTop = 0
              }}
            >
              联系我们
            </Link>
          </div> */}
            </li>
          </ul>
          <img
            className='Header_userIcon'
            src={`${dark || hovered ? '/images/nav/user_icon_black.svg' : getUserIcon()}`}
            alt="" />
          <img
            className='Header_languageIcon'
            src={`${dark || hovered ? '/images/nav/language_icon_black.svg' : getLanguageIcon()}`}
            alt="" />
        </div>
        {/* 移动端菜单按钮 */}
        <div
          className="Header_mobile"
          onClick={toggleMenu}
        >
          <img
            src={`${isMenuOpen ? '/images/nav/close_icon.svg' : (dark || hovered) ? '/images/nav/menu_icon_black.svg' : getMobileIcon()}`}
            alt="" />
        </div>
        {/* 移动端下拉菜单 */}
        <div className={`Header_mobile-navItem ${isMenuOpen ? 'open' : ''}`}>
          <div className='pageMargin'>
            <ul>
              <li>
                <div
                  className='Header_mobile-navItemText'
                  onClick={(() => {
                    navigate('/#homeCoverPage')
                    setIsMenuOpen(false)
                    setIsProductsOpen(false)
                  })}>
                  首页
                </div>
              </li>
              <li style={{ position: 'relative' }}>
                <div className='flex_row flex_jc-sb flex_ai-c' style={{ width: '100%' }}>
                  <div
                    className='Header_mobile-navItemText'
                    onClick={(() => {
                      navigate('/productsIndex#coverPage')
                      setIsMenuOpen(false)
                      setIsProductsOpen(false)
                    })}>
                    产品及解决方案
                  </div>
                  <img
                    className={`mobile-arrow ${isProductsOpen ? 'open' : ''}`}
                    src="/images/nav/expand_icon.svg"
                    alt=""
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleProductsMenu(e);
                    }}
                  />
                </div>
                <div className={`Header_mobile-sbuNav ${isProductsOpen ? 'open' : ''}`}>
                  <ul>
                    {solutionData.map((item, index) =>
                      <li key={index}>
                        <div
                          className='fz_12 fw_700 c_85899E'
                          onClick={(() => {
                            navigate(item.router)
                            setIsMenuOpen(false)
                            setIsProductsOpen(false)
                          })}>
                          {index < 3 && item.title}{item.subTitle}
                        </div>
                      </li>
                    )}
                  </ul>
                </div>
              </li>
              <li>
                <div
                  className='Header_mobile-navItemText'
                  onClick={(() => {
                    navigate('/companyNews')
                    setIsMenuOpen(false)
                    setIsProductsOpen(false)
                  })}>
                  公司动态
                </div>
              </li>
              <li>
                <div
                  className='Header_mobile-navItemText'
                  onClick={(() => {
                    navigate('/fcst')
                    setIsMenuOpen(false)
                    setIsProductsOpen(false)
                  })}>
                  FCST研究院
                </div>
              </li>
              <li>
                <div
                  className='Header_mobile-navItemText'
                  onClick={(() => {
                    navigate('/aboutUs')
                    setIsMenuOpen(false)
                    setIsProductsOpen(false)
                  })}>
                  关于我们
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
}
